// src/components/ScrollToTopButton.jsx
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Btn = styled.button`
  position: fixed;
  right: 16px;
  bottom: 20px;
  z-index: 1200;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: ${({theme})=>theme.radius.pill}px;
  border: 1px solid ${({theme})=>theme.border};
  background: ${({theme})=>theme.surface};
  color: ${({theme})=>theme.text};
  box-shadow: ${({theme})=>theme.shadow.sm};
  cursor: pointer;
  opacity: ${p => p.$show ? 1 : 0};
  transform: translateY(${p => p.$show ? 0 : 8}px);
  pointer-events: ${p => p.$show ? 'auto' : 'none'};
  transition: opacity .2s ease, transform .2s ease, background .2s ease, color .2s ease, border-color .2s ease;

  &:hover { border-color: ${({theme})=>theme.textMuted}; }
`;

export default function ScrollToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 280);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Btn
      type="button"
      aria-label="Scroll to top"
      title="Вгору"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      $show={show}
    >
      ↑
    </Btn>
  );
}
